module.exports = __webpack_public_path__ + "static/media/1.93adf1dd.JPG";